import { Exception } from 'src/app/core/logic/exception';

export class InvalidPictureFileTypeException extends Exception<never> {
  constructor() {
    super('Type de fichier invalide, types acceptés: jpeg/png');
  }
}
